import React from 'react';
import { Check } from 'lucide-react';
const bonuses = [{
  title: 'Checklist de trekking seguro',
  desc: 'Lista imprimible para que nunca más te olvides nada importante antes de salir.',
  img: 'https://images.unsplash.com/photo-1551632811-561732d1e306?w=600&q=80',
  value: '$4.990',
  exclusive: false
}, {
  title: 'Plan de entrenamiento',
  desc: 'Rutinas específicas en PDF para preparar tus piernas y pulmones.',
  img: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=600&q=80',
  value: '$7.990',
  exclusive: false
}, {
  title: 'Mapa de decisiones en ruta',
  desc: 'Guía visual rápida para saber qué hacer ante imprevistos o mal clima.',
  img: 'https://images.unsplash.com/photo-1533240332313-0db49b459ad6?w=600&q=80',
  value: '$5.990',
  exclusive: false
}, {
  title: 'Atlas Argentino de trekking',
  desc: 'Las mejores rutas del país clasificadas por dificultad y época del año.',
  img: 'https://images.unsplash.com/photo-1501554728187-ce583db33af7?w=600&q=80',
  value: '$12.990',
  exclusive: true
}];
export function Bonuses() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto" data-id="element-11">
      <div className="text-center mb-16" data-id="element-12">
        <div className="inline-block bg-trek-orange text-white px-4 py-1 rounded-full font-bold text-sm tracking-widest mb-4 animate-pulse" data-id="element-13">
          SOLO POR HOY
        </div>
        <h2 className="text-4xl sm:text-5xl font-display text-white mb-4" data-id="element-14">
          BONOS <span className="text-trek-orange" data-id="element-15">GRATIS</span> CON TU COMPRA
        </h2>
        <p className="text-trek-beige text-lg" data-id="element-16">
          Llevate estas herramientas complementarias sin costo adicional.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-17">
        {bonuses.map((bono, idx) => <div key={idx} className={`relative flex flex-col sm:flex-row gap-6 bg-trek-blackLight rounded-2xl overflow-hidden border ${bono.exclusive ? 'border-trek-orange shadow-[0_0_20px_rgba(224,122,44,0.2)]' : 'border-trek-brown'}`} data-id="element-18">
            {bono.exclusive && <div className="absolute top-4 -right-10 bg-trek-orange text-white text-xs font-bold py-1 px-10 rotate-45 shadow-lg z-10" data-id="element-19">
                EXCLUSIVO
              </div>}

            <div className="w-full sm:w-2/5 h-48 sm:h-auto relative" data-id="element-20">
              <img src={bono.img} alt={bono.title} className="w-full h-full object-cover" data-id="element-21" />
              <div className="absolute inset-0 bg-gradient-to-t from-trek-blackLight to-transparent sm:bg-gradient-to-r" data-id="element-22"></div>
            </div>

            <div className="w-full sm:w-3/5 p-6 flex flex-col justify-center" data-id="element-23">
              <div className="text-trek-orange font-bold text-sm mb-2" data-id="element-24">
                BONO {idx + 1}
              </div>
              <h3 className="text-xl font-display text-white mb-2 pr-4" data-id="element-25">
                {bono.title}
              </h3>
              <p className="text-trek-beige/80 text-sm mb-4" data-id="element-26">{bono.desc}</p>

              <div className="mt-auto" data-id="element-27">
                <p className="text-sm text-trek-beige/50 line-through mb-1" data-id="element-28">
                  Valor normal: {bono.value}
                </p>
                <p className="text-trek-orange font-bold flex items-center gap-2" data-id="element-29">
                  <Check size={16} data-id="element-30" /> HOY GRATIS
                </p>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}